(function() {
  function initializeReviewsCore() {
    const root = document.getElementById('shopify-universal-reviews');
    if (!root) return;

    // 1. 从专用 JSON Script 标签安全读取数据（消除 HTML 属性转义膨胀与两次 parse）
    const dataEl = document.getElementById('shopify-universal-reviews-data');
    const statsEl = document.getElementById('shopify-universal-reviews-stats');

    let rawReviews = [];
    if (dataEl && dataEl.textContent) {
      try {
        rawReviews = JSON.parse(dataEl.textContent);
      } catch(e) {
        console.error("[Reviews] JSON parse fail", e);
      }
    } else if (root.dataset.reviews) {
      // 兼容性降级
      try {
        rawReviews = JSON.parse(root.dataset.reviews);
        if (typeof rawReviews === 'string') rawReviews = JSON.parse(rawReviews);
      } catch(e) {}
    }
    if (!Array.isArray(rawReviews)) rawReviews = [];

    let stats = {};
    if (statsEl && statsEl.textContent) {
      try {
        stats = JSON.parse(statsEl.textContent);
      } catch(e) {}
    } else if (root.dataset.stats) {
      try {
        stats = JSON.parse(root.dataset.stats);
        if (typeof stats === 'string') stats = JSON.parse(stats);
      } catch(e) {}
    }

    // 数据清洗与媒体剥离
    function extractMediaArray(reviewObj) {
      if (!reviewObj) return [];
      let rawMedia = reviewObj.media_urls || reviewObj.media_url || reviewObj.images || reviewObj.image_urls || reviewObj.media || [];
      let cleanArr = [];

      try {
        if (Array.isArray(rawMedia)) cleanArr = rawMedia;
        else if (typeof rawMedia === 'string') {
          let parsed = JSON.parse(rawMedia.trim());
          if (typeof parsed === 'string') parsed = JSON.parse(parsed.trim());
          if (Array.isArray(parsed)) cleanArr = parsed;
        }
      } catch(e) {
        const matches = String(rawMedia).match(/https?:\/\/[^\s"']+/g);
        if (matches) cleanArr = matches;
      }
      
      if (Array.isArray(cleanArr) && cleanArr.length > 0 && typeof cleanArr[0] === 'object' && cleanArr[0] !== null) {
        cleanArr = cleanArr.map(item => item.url || item.image || item.src || '').filter(Boolean);
      }

      return cleanArr.map(url => {
        return String(url).replace(/\\/g, '').replace(/["']/g, '').replace(/[\[\]]/g, '').trim();
      }).filter(url => url.length > 10 && url.startsWith('http'));
    }

    // 双权排序逻辑：1. 有媒体优先 2. 时间倒序
    rawReviews.sort((a, b) => {
      const mediaA = extractMediaArray(a).length > 0 ? 1 : 0;
      const mediaB = extractMediaArray(b).length > 0 ? 1 : 0;
      if (mediaA !== mediaB) return mediaB - mediaA;
      const timeA = a.created_at ? Date.parse(a.created_at) : 0;
      const timeB = b.created_at ? Date.parse(b.created_at) : 0;
      return timeB - timeA;
    });

    rawReviews.forEach((r, index) => { r.review_unique_id = "rev_id_" + index; });

    const dataset = { ALL: rawReviews, PHOTOS: rawReviews.filter(r => extractMediaArray(r).length > 0) };

    function updateTabsCountDisplay() {
      const pcAll = document.getElementById('pc-count-all');
      const pcPhotos = document.getElementById('pc-count-photos');
      const mbAll = document.getElementById('mb-count-all');
      const mbPhotos = document.getElementById('mb-count-photos');
      if (pcAll) { pcAll.innerText = dataset.ALL.length; pcAll.classList.add('review-fade-in'); }
      if (pcPhotos) { pcPhotos.innerText = dataset.PHOTOS.length; pcPhotos.classList.add('review-fade-in'); }
      if (mbAll) { mbAll.innerText = dataset.ALL.length; mbAll.classList.add('review-fade-in'); }
      if (mbPhotos) { mbPhotos.innerText = dataset.PHOTOS.length; mbPhotos.classList.add('review-fade-in'); }
    }

    function revealHeaderRealContent() {
      document.querySelectorAll('.score-stars-skeleton, .score-num-skeleton, .mb-stars-skeleton, .mb-drawer-stars-skeleton, .mb-drawer-num-skeleton').forEach(el => el.remove());
      document.querySelectorAll('.review-header-real-elem').forEach(el => {
        el.style.display = '';
        el.classList.add('review-fade-in');
      });
      const mbDrawerReal = document.querySelector('.mb-drawer-score-real');
      if (mbDrawerReal) {
        mbDrawerReal.style.display = 'flex';
        mbDrawerReal.classList.add('review-fade-in');
      }
    }

    let pcTab = 'ALL'; let pcPage = 1; const pcPageSize = 5; 
    let mbTab = 'ALL'; let mbLoadedCount = 3; const mbIncrement = 3;
    
    // 灯箱全局变量
    let currentLightboxReviewNode = null; 
    let currentLightboxMediaGroup = []; 
    let currentLightboxIndex = 0;
    
    // 手势与硬件观察器变量
    let mbInfiniteScrollObserver = null;

    // JS 端的高精度 SVG 星星生成器 (复用 CSS 组件)
    const singleSvgIcon = `<svg class="star-svg-icon" viewBox="0 0 24 24" fill="currentColor"><path d="M12 17.27l4.15 2.51c.76.46 1.69-.22 1.49-1.08l-1.1-4.72 3.67-3.18c.67-.58.31-1.68-.57-1.75l-4.83-.41-1.89-4.46c-.34-.81-1.5-.81-1.84 0L9.19 8.63l-4.83.41c-.88.07-1.24 1.17-.57 1.75l3.67 3.18-1.1 4.72c-.2.86.73 1.54 1.49 1.08l4.15-2.5z"/></svg>`;
    const groupOfFiveIcons = singleSvgIcon.repeat(5);

    function renderDynamicSvgStars(ratingVal, size) {
      const parsedRating = parseFloat(ratingVal);
      const currentRating = !isNaN(parsedRating) ? parsedRating : 5.0;
      const percentage = Math.min(Math.max(currentRating * 20, 0), 100);
      
      return `<div class="star-box" style="--star-size: ${size};" aria-label="${currentRating} stars">
                <div class="star-box-bg">${groupOfFiveIcons}</div>
                <div class="star-box-fg" style="width: ${percentage}%;">${groupOfFiveIcons}</div>
              </div>`;
    }

    function generateEmptyStateHtml() {
      return `
        <div class="reviews-empty-placeholder-wrapper">
          <svg class="icon" viewBox="0 0 1462 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="120" height="120">
            <path d="M673.192229 403.426743l300.163657 82.475886v288.607085l-300.163657-129.316571V403.426743z" fill="#ACACAD"></path>
            <path d="M673.543314 403.704686L428.383086 472.210286v303.264914l245.160228-131.262171V403.704686z" fill="#C2C1C1"></path>
            <path d="M619.461486 521.771886l-7.9872-3.744915c2.589257-5.500343 5.5296-11.146971 8.777143-16.778971l7.636114 4.388571a237.524114 237.524114 0 0 0-8.426057 16.135315z m75.805257-3.759543a79.389257 79.389257 0 0 1-18.914743-5.207772l3.335314-8.118857a70.392686 70.392686 0 0 0 16.808229 4.637257z m19.748571 0l-1.258057-8.674743a64.760686 64.760686 0 0 0 16.647314-4.842057l3.525486 8.031086a73.142857 73.142857 0 0 1-18.914743 5.456457z m-55.778743-14.350629a121.270857 121.270857 0 0 1-15.125942-11.951543l5.968457-6.436571a112.128 112.128 0 0 0 14.014171 11.073829z m91.5456-0.892343l-5.149257-7.109485c2.413714-1.7408 4.827429-3.671771 7.211886-5.7344a81.773714 81.773714 0 0 0 6.129371-5.851429l6.421943 5.968457a83.280457 83.280457 0 0 1-6.802285 6.538972c-2.574629 2.2528-5.2224 4.271543-7.811658 6.158628z" fill="#CCCCCC"></path>
          </svg>
          <p class="reviews-empty-placeholder-text">No reviews found in this tab.</p>
        </div>`;
    }

    // 灯箱核心组件
    function lightboxKeydownHandler(e) {
      if (!document.getElementById('review-lightbox-modal')?.classList.contains('active')) return;
      if (e.key === 'Escape') closeLightboxModal();
      if (e.key === 'ArrowRight') handleLightboxNext();
      if (e.key === 'ArrowLeft') handleLightboxPrev();
    }

    window.openReviewLightbox = function(reviewUniqueId, startIndex) {
      currentLightboxReviewNode = rawReviews.find(r => r.review_unique_id === reviewUniqueId);
      if (!currentLightboxReviewNode) return;
      currentLightboxMediaGroup = extractMediaArray(currentLightboxReviewNode);
      currentLightboxIndex = parseInt(startIndex) || 0;
      if (currentLightboxMediaGroup.length === 0) return;
      
      const portal = document.getElementById('lightbox-portal-container');
      if (!portal) return;

      portal.innerHTML = `
        <div class="review-lightbox-modal" id="review-lightbox-modal">
          <div class="lightbox-blur-bg" id="lightbox-bg-closer"> </div>
          <button class="lightbox-close-btn" id="lightbox-close-btn" aria-label="Close">✕</button>
          <div class="lightbox-main-card">
            <div class="lightbox-stage-area">
              <div class="lightbox-shimmer-backdrop" id="lightbox-media-shimmer"><div class="shimmer-wave-line"></div></div>
              <div class="lightbox-media-render" id="lightbox-media-render"></div>
              <div class="pc-lightbox-control-bar">
                <button class="lightbox-arrow-btn" id="lightbox-prev-btn" aria-label="Previous">＜</button>
                <div class="lightbox-counter-badge" id="lightbox-counter">1/1</div>
                <button class="lightbox-arrow-btn" id="lightbox-next-btn" aria-label="Next">＞</button>
              </div>
              <div class="mb-lightbox-dock-panel" id="mb-lightbox-dock">
                <div class="mb-dock-user-row">
                  <span class="mb-dock-username" id="mb-dock-user-title"></span>
                  <span class="mb-dock-specs" id="mb-dock-specs-render"></span>
                </div>
                <div class="mb-dock-stars" id="mb-dock-stars-render"></div>
                <p class="mb-dock-body" id="mb-dock-body-render"></p>
              </div>
            </div>
            <div class="lightbox-info-sidebar" id="lightbox-sidebar"></div>
          </div>
        </div>
      `;

      document.body.style.overflow = 'hidden';
      const m = document.getElementById('review-lightbox-modal');
      setTimeout(() => { if (m) m.classList.add('active'); }, 10);

      document.getElementById('lightbox-close-btn')?.addEventListener('click', closeLightboxModal);
      document.getElementById('lightbox-bg-closer')?.addEventListener('click', closeLightboxModal);
      document.getElementById('lightbox-prev-btn')?.addEventListener('click', handleLightboxPrev);
      document.getElementById('lightbox-next-btn')?.addEventListener('click', handleLightboxNext);
      document.addEventListener('keydown', lightboxKeydownHandler);

      renderLightboxStage();
    };

    function renderLightboxStage() {
      const stage = document.getElementById('lightbox-media-render');
      const counter = document.getElementById('lightbox-counter');
      const prevBtn = document.getElementById('lightbox-prev-btn');
      const nextBtn = document.getElementById('lightbox-next-btn');
      const sidebar = document.getElementById('lightbox-sidebar');
      const shimmer = document.getElementById('lightbox-media-shimmer');
      
      const targetUrl = currentLightboxMediaGroup[currentLightboxIndex];
      if (!targetUrl || !stage) return;

      if (shimmer && window.innerWidth >= 768) { shimmer.classList.add('is-active'); }

      const isVideo = /\.(mp4|webm|mov|avi|m3u8)(\?|$)/i.test(targetUrl) || targetUrl.toLowerCase().includes('video');
      
      if (isVideo) {
        stage.innerHTML = `<video src="${targetUrl}" id="lightbox-core-video" controls muted playsinline webkit-playsinline="true" x5-playsinline="true" x5-video-player-type="h5-page" crossorigin="anonymous" preload="metadata" style="width: 100% !important; height: 100% !important; max-height: 65vh; object-fit: contain !important; background: #000000 !important; display: block !important;"></video>`;
        setTimeout(() => {
          const v = document.getElementById('lightbox-core-video');
          if(v) {
            const mediaLoaded = () => { if (shimmer) shimmer.classList.remove('is-active'); v.classList.add('media-fully-loaded'); };
            v.onloadedmetadata = mediaLoaded;
            v.onloadeddata = mediaLoaded;
            v.load(); 
            Promise.resolve().then(() => { 
              const p = v.play(); 
              if (p !== undefined) {
                p.catch(() => { v.currentTime = 0.1; }); 
              }
            });
          }
        }, 40);
      } else {
        stage.innerHTML = `<img src="${targetUrl}" id="lightbox-core-img" alt="Enlarged Media">`;
        const img = document.getElementById('lightbox-core-img');
        if (img) {
          const handleMediaLoaded = () => {
            if (shimmer) shimmer.classList.remove('is-active');
            img.classList.add('media-fully-loaded');
          };
          if (img.complete) {
            handleMediaLoaded();
          } else {
            img.onload = handleMediaLoaded;
            img.onerror = function() { 
              if (shimmer) shimmer.classList.remove('is-active'); 
            };
          }
        }
      }

      const r = currentLightboxReviewNode;
      const specParts = []; if (r.color) specParts.push(r.color); if (r.size) specParts.push(r.size);
      let formattedDate = '';
      if (r.created_at) {
        const d = new Date(r.created_at);
        if (!isNaN(d.getTime())) formattedDate = `${String(d.getMonth() + 1).padStart(2, '0')}/${String(d.getDate()).padStart(2, '0')}/${d.getFullYear()}`;
      }
      
      if (sidebar) {
        sidebar.innerHTML = `
          <div class="lb-sidebar-user">${r.user_name || 'Anonymous'}</div>
          <div class="lb-sidebar-date">in US on ${formattedDate}</div>
          <div class="lb-sidebar-stars">${renderDynamicSvgStars(r.rating || 5, '15px')}</div>
          ${specParts.length > 0 ? `<div class="lb-sidebar-specs">${specParts.join('/')}</div>` : ''}
          <p class="lb-sidebar-body">${r.body || ''}</p>
        `;
      }

      const dockUser = document.getElementById('mb-dock-user-title');
      if (dockUser) {
        dockUser.innerText = r.user_name || 'Anonymous';
        document.getElementById('mb-dock-stars-render').innerHTML = renderDynamicSvgStars(r.rating || 5, '14px');
        document.getElementById('mb-dock-specs-render').innerText = specParts.length > 0 ? specParts.join('/') : '';
        document.getElementById('mb-dock-body-render').innerText = r.body || '';
      }

      if (counter) counter.innerText = `${currentLightboxIndex + 1} / ${currentLightboxMediaGroup.length}`;
      if (prevBtn) prevBtn.disabled = currentLightboxIndex === 0;
      if (nextBtn) nextBtn.disabled = currentLightboxIndex === currentLightboxMediaGroup.length - 1;
    }

    function triggerStageTransition() {
      const stage = document.getElementById('lightbox-media-render');
      if (stage) stage.classList.add('is-switching'); 
      setTimeout(() => {
        renderLightboxStage(); 
        if (stage) stage.classList.remove('is-switching'); 
      }, 250); 
    }

    function handleLightboxNext() { if (currentLightboxIndex < currentLightboxMediaGroup.length - 1) { currentLightboxIndex++; triggerStageTransition(); } }
    function handleLightboxPrev() { if (currentLightboxIndex > 0) { currentLightboxIndex--; triggerStageTransition(); } }

    function closeLightboxModal() {
      const m = document.getElementById('review-lightbox-modal');
      if(m) m.classList.remove('active');
      document.removeEventListener('keydown', lightboxKeydownHandler);
      setTimeout(() => {
        const portal = document.getElementById('lightbox-portal-container');
        if (portal) portal.innerHTML = '';
        const drawer = document.getElementById('mb-reviews-drawer');
        if (!drawer || !drawer.classList.contains('active')) {
          document.body.style.overflow = '';
        }
      }, 200);
    }

    function closeMobileDrawer() {
      destroyMobileObserver(); 
      const drawer = document.getElementById('mb-reviews-drawer');
      if (drawer) drawer.classList.remove('active');
      document.body.style.overflow = ''; 
    }

    function renderPCStats() {
      const side = document.getElementById('pc-dynamic-stats-container');
      if (!side) return;

      let hasFormContent = false;
      if (stats && stats.form) {
        for (const k in stats.form) { if (stats.form[k] && Object.keys(stats.form[k]).length > 0) { hasFormContent = true; break; } }
      }

      if (hasFormContent) {
        side.innerHTML = generateStatsHtmlGroup(stats);
      } else {
        const total = Number(stats.count || rawReviews.length || 1);
        const distribution = stats.distribution || stats.rating_distribution || {};
        
        let breakdownHtml = `<div class="reviews-rating-breakdown">`;
        for (let star = 5; star >= 1; star--) {
          const count = Number(distribution[star] || distribution[String(star)] || rawReviews.filter(r => Number(r.rating) === star).length || 0);
          const pct = Math.round((count / total) * 100);
          breakdownHtml += `
            <div class="breakdown-row">
              <span class="breakdown-label">${star} <svg viewBox="0 0 24 24" fill="currentColor" style="width:12px; height:12px;"><path d="M12 17.27l4.15 2.51c.76.46 1.69-.22 1.49-1.08l-1.1-4.72 3.67-3.18c.67-.58.31-1.68-.57-1.75l-4.83-.41-1.89-4.46c-.34-.81-1.5-.81-1.84 0L9.19 8.63l-4.83.41c-.88.07-1.24 1.17-.57 1.75l3.67 3.18-1.1 4.72c-.2.86.73 1.54 1.49 1.08l4.15-2.5z"/></svg></span>
              <div class="breakdown-bar-bg"><div class="breakdown-bar-fill" style="width: ${pct}%;"></div></div>
              <span class="breakdown-count">(${count})</span>
            </div>
          `;
        }
        breakdownHtml += `</div>`;
        side.innerHTML = breakdownHtml;
      }
      side.classList.add('review-fade-in');
    }

    function renderPCList() {
      const listDOM = document.getElementById('pc-reviews-list');
      if (!listDOM) return;

      const list = dataset[pcTab] || []; const total = list.length;
      const totalPages = Math.ceil(total / pcPageSize) || 1;
      if (pcPage > totalPages) pcPage = totalPages;

      const start = (pcPage - 1) * pcPageSize; 
      const end = Math.min(start + pcPageSize, total);
      const pageData = list.slice(start, end);

      if (pageData.length === 0) {
        listDOM.innerHTML = generateEmptyStateHtml();
        const pBtn = document.getElementById('pc-pagination-buttons');
        if (pBtn) pBtn.innerHTML = '';
      } else {
        listDOM.innerHTML = pageData.map(r => generateReviewCardHtml(r)).join('');
      }

      const infoText = document.getElementById('pc-pagination-info');
      if (infoText) infoText.innerText = total > 0 ? `${start + 1} - ${end} of ${total} Results` : `0 Results`;

      const btnGroup = document.getElementById('pc-pagination-buttons');
      if (!btnGroup) return;
      if (totalPages <= 1) { btnGroup.innerHTML = ''; return; }
      
      let h = `<button class="pag-arrow-btn" ${pcPage === 1 ? 'disabled' : ''} data-dir="prev" title="Previous Page"><svg class="arrow-svg-left" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path d="M724 218.3L651.2 145 276 512l375.2 367 72.8-73.3L421.7 512z"/></svg></button>`;
      for (let p = 1; p <= totalPages; p++) {
        if (p === 1 || p === totalPages || (p >= pcPage - 1 && p <= pcPage + 1)) {
          h += `<button class="pag-num-btn ${p === pcPage ? 'active' : ''}" data-page="${p}">${p}</button>`;
        } else if (p === pcPage - 2 || p === pcPage + 2) {
          h += `<span style="color:#b5b5b5; padding:0 4px; font-weight:300; pointer-events:none;">...</span>`;
        }
      }
      h += `<button class="pag-arrow-btn" ${pcPage === totalPages ? 'disabled' : ''} data-dir="next" title="Next Page"><svg class="arrow-svg-right" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path d="M300 218.3l72.8-73.3L748 512 372.8 879 300 805.7 602.3 512z"/></svg></button>`;
      if (pageData.length > 0) btnGroup.innerHTML = h;
    }

    function renderMobileInfiniteList() {
      const listDOM = document.getElementById('mb-infinite-reviews-list');
      if (!listDOM) return;
      const filteredList = dataset[mbTab] || []; const total = filteredList.length;

      if (total === 0) { 
        listDOM.innerHTML = generateEmptyStateHtml(); toggleLoadingAnchor(false); return; 
      }
      const currentSlice = filteredList.slice(0, mbLoadedCount);
      listDOM.innerHTML = currentSlice.map(r => generateReviewCardHtml(r)).join('');
      toggleLoadingAnchor(mbLoadedCount < total);
    }

    // 优化项四：构建列表卡片（封面图优先，视频首帧#t=0.001+preload=none，图片decoding=async）
    function generateReviewCardHtml(r) {
      const mediaArr = extractMediaArray(r);
      let formVals = {}; try { formVals = JSON.parse(r.form_values || '{}'); } catch(e) {}
      const specParts = []; if (r.color) specParts.push(r.color); if (r.size) specParts.push(r.size);
      
      let formattedDate = '';
      if (r.created_at) {
        const d = new Date(r.created_at);
        if (!isNaN(d.getTime())) formattedDate = `${String(d.getMonth() + 1).padStart(2, '0')}/${String(d.getDate()).padStart(2, '0')}/${d.getFullYear()}`;
      }

      const fitHtml = Object.entries(formVals).map(([k, o]) => `<span>${k}: ${Array.isArray(o.value) ? o.value.join(', ') : o.value}</span>`).join(' | ');
      
      let mediaGridHtml = '';
      if (mediaArr.length > 0) {
        mediaGridHtml = `<div class="review-media-grid">`;
        mediaArr.forEach((url, imgIndex) => {
          if (!url) return;
          const isVideo = /\.(mp4|webm|mov|avi|m3u8)(\?|$)/i.test(url) || url.toLowerCase().includes('video');
          if (isVideo) {
            // 视频防盗流：利用 #t=0.001 精确拉取首帧，preload=none 禁止预载整流
            const videoThumb = url.includes('#t=') ? url : `${url}#t=0.001`;
            mediaGridHtml += `<div class="review-media-wrapper" onclick="window.openReviewLightbox('${r.review_unique_id}', ${imgIndex})"><video src="${videoThumb}" preload="none" muted playsinline></video><div class="video-play-indicator"></div></div>`;
          } else {
            mediaGridHtml += `<div class="review-media-wrapper" onclick="window.openReviewLightbox('${r.review_unique_id}', ${imgIndex})"><img src="${url}" loading="lazy" decoding="async" onerror="this.parentNode.style.display='none';"></div>`;
          }
        });
        mediaGridHtml += `</div>`;
      }

      return `
        <div class="review-card-node review-fade-in">
          <div class="node-meta">
            <span>${r.user_name || 'Anonymous'}</span>
            <span class="node-date">in US on ${formattedDate}</span>
          </div>
          <div class="node-stars">${renderDynamicSvgStars(r.rating || 5, '14px')}</div>
          ${specParts.length > 0 ? `<div class="node-specs">${specParts.join('/')}</div>` : ''}
          <p class="node-body">${r.body || ''}</p>
          ${mediaGridHtml}
          ${fitHtml ? `<div class="node-fit">Fit: ${fitHtml}</div>` : ''}
        </div>`;
    }

    function generateStatsHtmlGroup(targetStats) {
      if (!targetStats || !targetStats.form) return '';
      const total = Number(targetStats.count || 0); let formOptions = {};
      for (const k in targetStats.form) { if (targetStats.form[k] && Object.keys(targetStats.form[k]).length > 0) { formOptions = targetStats.form[k]; break; } }
      return Object.entries(formOptions).map(([name, count]) => {
        const pct = total > 0 ? Math.round((Number(count) / total) * 100) : 0;
        return `<div class="stats-row-item"><span class="stats-label" title="${name}">${name}</span><div class="stats-progress-bg"><div class="stats-progress-fill" style="width:${pct}%;"></div></div><span class="stats-value-output">${pct}%</span></div>`;
      }).join('');
    }

    function initMobilePreviewHeader() {
      const hotTextDOM = document.getElementById('mb-hot-form-text'); if (!hotTextDOM) return;
      let hasForm = false;
      if (stats && stats.form) {
        for (const k in stats.form) {
          const options = stats.form[k]; const entries = Object.entries(options);
          if (entries.length > 0) {
            let maxOption = entries[0]; entries.forEach(e => { if(Number(e[1]) > Number(maxOption[1])) maxOption = e; });
            const total = Number(stats.count || 1); const percent = Math.round((Number(maxOption[1]) / total) * 100);
            hotTextDOM.innerText = `${k}: ${maxOption[0]} (${percent}%)`; hasForm = true; break;
          }
        }
      }
      if (!hasForm) hotTextDOM.innerText = `Customers Say: True to size (100%)`;
      hotTextDOM.classList.add('review-fade-in');
    }

    function renderMobileHorizontalSwiper() {
      const swiperContainer = document.getElementById('mb-horizontal-swiper'); if (!swiperContainer) return;
      if (rawReviews.length === 0) { swiperContainer.innerHTML = `<div>No reviews available.</div>`; return; }
      
      swiperContainer.innerHTML = rawReviews.map(r => {
        const mediaArr = extractMediaArray(r);
        let mediaHtml = '';
        
        if (mediaArr.length > 0) {
          mediaHtml = `<div class="mb-card-media-row">`;
          mediaArr.slice(0, 4).forEach((url, imgIndex) => {
            const isVideo = /\.(mp4|webm|mov|avi|m3u8)(\?|$)/i.test(url) || url.toLowerCase().includes('video');
            if (isVideo) {
              const videoThumb = url.includes('#t=') ? url : `${url}#t=0.001`;
              mediaHtml += `<div class="mb-card-media-box" onclick="window.openReviewLightbox('${r.review_unique_id}', ${imgIndex})"><video src="${videoThumb}" preload="none" muted playsinline></video><div class="video-play-indicator" style="transform: translate(-50%, -50%) scale(0.65);"></div></div>`;
            } else {
              mediaHtml += `<div class="mb-card-media-box" onclick="window.openReviewLightbox('${r.review_unique_id}', ${imgIndex})"><img src="${url}" loading="lazy" decoding="async" onerror="this.style.display='none';"></div>`;
            }
          });
          mediaHtml += `</div>`;
        }

        return `
          <div class="mb-swiper-card review-fade-in">
            <div class="mb-card-user"><span>${r.user_name || 'Anonymous'}</span></div>
            <div class="node-stars" style="margin-bottom: 8px;">${renderDynamicSvgStars(r.rating || 5, '12px')}</div>
            <p class="mb-card-body">${r.body || ''}</p>
            ${mediaHtml}
          </div>
        `;
      }).join('');
    }

    function toggleLoadingAnchor(show) { const anchor = document.getElementById('mb-infinite-loading-anchor'); if(anchor) { if (show) anchor.classList.add('loading'); else anchor.classList.remove('loading'); } }
    
    function setupMobileInfiniteObserver() {
      const anchor = document.getElementById('mb-infinite-loading-anchor');
      const scrollArea = document.getElementById('mb-drawer-scroll-area');
      if (!anchor || !scrollArea) return;

      const options = { root: scrollArea, rootMargin: '0px 0px 150px 0px', threshold: 0.1 };

      mbInfiniteScrollObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          const filteredList = dataset[mbTab] || [];
          if (entry.isIntersecting && mbLoadedCount < filteredList.length && !anchor.dataset.rendering) {
            anchor.dataset.rendering = "true"; 
            setTimeout(() => {
              mbLoadedCount += mbIncrement;
              renderMobileInfiniteList();
              anchor.removeAttribute('data-rendering'); 
            }, 200);
          }
        });
      }, options);

      mbInfiniteScrollObserver.observe(anchor);
    }

    function destroyMobileObserver() {
      if (mbInfiniteScrollObserver) {
        mbInfiniteScrollObserver.disconnect();
        mbInfiniteScrollObserver = null;
      }
      const anchor = document.getElementById('mb-infinite-loading-anchor');
      if (anchor) anchor.removeAttribute('data-rendering');
    }

    function updatePCUnderline() { const active = document.querySelector('.reviews-pc-layout .tab-btn.active'); const line = document.getElementById('pc-tab-underline'); if (active && line) { line.style.left = active.offsetLeft + 'px'; line.style.width = active.offsetWidth + 'px'; } }
    function updateMobileTabUnderline() { const active = document.querySelector('.mb-drawer-tabs .tab-btn.active'); const line = document.getElementById('mb-tab-underline'); if (active && line) { line.style.left = active.offsetLeft + 'px'; line.style.width = active.offsetWidth + 'px'; } }

    // Tab 与分页丝滑平滑过渡逻辑 (PC与移动端)
    let isPCTabSwitching = false;
    function switchPCTab(newTab) {
      if (pcTab === newTab || isPCTabSwitching) return;
      const listDOM = document.getElementById('pc-reviews-list');
      if (!listDOM) return;

      isPCTabSwitching = true;
      pcTab = newTab;
      pcPage = 1;

      if (newTab === 'ALL') {
        document.getElementById('pc-tab-photos')?.classList.remove('active');
        document.getElementById('pc-tab-all')?.classList.add('active');
      } else {
        document.getElementById('pc-tab-all')?.classList.remove('active');
        document.getElementById('pc-tab-photos')?.classList.add('active');
      }
      updatePCUnderline();

      listDOM.classList.add('is-tab-switching');
      setTimeout(() => {
        renderPCList();
        listDOM.classList.remove('is-tab-switching');
        isPCTabSwitching = false;
      }, 160);
    }

    let isMobileTabSwitching = false;
    function switchMobileTab(newTab) {
      if (mbTab === newTab || isMobileTabSwitching) return;
      const listDOM = document.getElementById('mb-infinite-reviews-list');
      if (!listDOM) return;

      isMobileTabSwitching = true;
      mbTab = newTab;
      mbLoadedCount = 3;

      if (newTab === 'ALL') {
        document.getElementById('mb-tab-photos')?.classList.remove('active');
        document.getElementById('mb-tab-all')?.classList.add('active');
      } else {
        document.getElementById('mb-tab-all')?.classList.remove('active');
        document.getElementById('mb-tab-photos')?.classList.add('active');
      }
      updateMobileTabUnderline();
      destroyMobileObserver();

      listDOM.classList.add('is-tab-switching');
      setTimeout(() => {
        renderMobileInfiniteList();
        const scrollArea = document.getElementById('mb-drawer-scroll-area');
        if (scrollArea) scrollArea.scrollTop = 0;
        setupMobileInfiniteObserver();
        listDOM.classList.remove('is-tab-switching');
        isMobileTabSwitching = false;
      }, 160);
    }

    // 绑定事件
    document.getElementById('pc-tab-all')?.addEventListener('click', () => switchPCTab('ALL'));
    document.getElementById('pc-tab-photos')?.addEventListener('click', () => switchPCTab('PHOTOS'));
    document.getElementById('mb-tab-all')?.addEventListener('click', () => switchMobileTab('ALL'));
    document.getElementById('mb-tab-photos')?.addEventListener('click', () => switchMobileTab('PHOTOS'));

    document.getElementById('pc-pagination-buttons')?.addEventListener('click', function(e) {
      const page = e.target.closest('.pag-num-btn')?.dataset.page;
      const dir = e.target.closest('.pag-arrow-btn')?.dataset.dir;
      const listDOM = document.getElementById('pc-reviews-list');
      if (!listDOM || isPCTabSwitching) return;

      const totalPages = Math.ceil((dataset[pcTab] || []).length / pcPageSize) || 1;
      let targetPage = null;
      if (page) {
        targetPage = parseInt(page);
      } else if (dir === 'prev' && pcPage > 1) {
        targetPage = pcPage - 1;
      } else if (dir === 'next' && pcPage < totalPages) {
        targetPage = pcPage + 1;
      }

      if (targetPage && targetPage !== pcPage) {
        isPCTabSwitching = true;
        pcPage = targetPage;
        listDOM.classList.add('is-tab-switching');
        setTimeout(() => {
          renderPCList();
          listDOM.classList.remove('is-tab-switching');
          isPCTabSwitching = false;
          window.scrollTo({ top: root.offsetTop - 40, behavior: 'smooth' });
        }, 140);
      }
    });

    document.getElementById('mb-preview-trigger')?.addEventListener('click', function(e) {
      e.preventDefault(); 
      document.getElementById('mb-reviews-drawer')?.classList.add('active'); 
      document.body.style.overflow = 'hidden'; 
      mbTab = 'ALL'; mbLoadedCount = 3; 
      document.getElementById('mb-tab-photos')?.classList.remove('active');
      document.getElementById('mb-tab-all')?.classList.add('active');
      destroyMobileObserver(); renderMobileInfiniteList(); 
      const statsPanel = document.getElementById('mb-drawer-dynamic-stats');
      if (statsPanel) statsPanel.innerHTML = generateStatsHtmlGroup(stats);
      setTimeout(() => { updateMobileTabUnderline(); setupMobileInfiniteObserver(); }, 50);
    });

    document.getElementById('mb-drawer-close')?.addEventListener('click', closeMobileDrawer);
    document.getElementById('mb-reviews-drawer')?.addEventListener('click', function(e) { if (e.target === this) { closeMobileDrawer(); } });

    // 优化项二：双端精准分流渲染
    const isDesktop = window.innerWidth >= 768;
    let isRenderedPC = false;
    let isRenderedMB = false;

    revealHeaderRealContent();
    updateTabsCountDisplay();

    if (isDesktop) {
      renderPCStats();
      renderPCList();
      isRenderedPC = true;
      setTimeout(updatePCUnderline, 150);
    } else {
      initMobilePreviewHeader();
      renderMobileHorizontalSwiper();
      isRenderedMB = true;
    }

    // 视口尺寸变化时懒渲染另一端
    window.addEventListener('resize', () => {
      const currentDesktop = window.innerWidth >= 768;
      if (currentDesktop) {
        if (!isRenderedPC) {
          renderPCStats();
          renderPCList();
          isRenderedPC = true;
        }
        updatePCUnderline();
      } else {
        if (!isRenderedMB) {
          initMobilePreviewHeader();
          renderMobileHorizontalSwiper();
          isRenderedMB = true;
        }
        updateMobileTabUnderline();
      }
    });
  }

  // 优化项一：视口相交懒初始化 (IntersectionObserver，距离400px预加载)
  function setupIntersectionObserver() {
    const root = document.getElementById('shopify-universal-reviews');
    if (!root) return;

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (entries[0] && entries[0].isIntersecting) {
          observer.disconnect();
          initializeReviewsCore();
        }
      }, { rootMargin: '400px 0px' });
      observer.observe(root);
    } else {
      initializeReviewsCore();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupIntersectionObserver);
  } else {
    setupIntersectionObserver();
  }
})();
